export const attestBookModule = {
  iconComponent: 'personal-icon',
  title: 'ОЦЕНЯВАНЕ НА<br> ПЕРСОНАЛА',
  details: [
    {
      text: 'Атестиране на педагогическите специалисти по Наредба № 15 от 22.07.2019 г.'
    },
    {
      text: 'ДТВ за постигнати резултати от труда на персонала по Наредба № 4 от 20.04.2017 г.'
    },
    {
      text: 'Изготвяне на професионално портфолио'
    },
    {
      text: 'Различни абонаментни пакети, включващи примерна документация и AI консултант'
    }
  ]
}

export const administrationModule = {
  iconComponent: 'admin-icon',
  title: 'АДМИНИСТРАЦИЯ',
  details: [
    {
      text: 'Актуализиране на данни от НЕИСПУО'
    },
    {
      text: 'Генериране на персонални идентификационни кодове за достъп до платформата'
    },
    {
      text: 'Лесно управление на достъпа до АдминПлюс от администратора'
    },
  ]
}

export const reportModule = {
  iconComponent: 'report-icon',
  title: 'СПРАВКИ',
  details: [
    {
      text: 'Генериране на справки с данните от модул „Списък-образец“ от платформата АдминПлюс'
    },
    {
      text: 'Генериране на справки с данните от модул „Електронен дневник“ от платформата АдминПлюс'
    },
    {
      text: 'Споделяне на справките със служителите от институцията, които имат достъп до модула'
    },
    {
      text: 'Прехвърляне на готовите справки в Excel'
    },
  ]
}

export const booksModule = {
  iconComponent: 'kd-icon',
  title: 'КНИГИ ЗА ДЕЙНОСТТА',
  details: [
    {
      text: 'Книга за регистриране заповедите на директора'
    },
    {
      text: 'Книга за контролната дейност на директора/заместник-директора'
    },
    {
      text: 'Книга за решенията на педагогическия съвет'
    },
    {
      text: 'Дневници за входяща и изходяща кореспонденция'
    },
  ]
}

export const studentProfileModule = {
  iconComponent: 'student-icon',
  title: 'УЧЕНИЧЕСКИ<br>ПРОФИЛ',
  details: [
    {
      text: 'Обобщена информация за всеки ученик'
    },
    {
      text: 'Преглед на подадените документи за уважаване на отсъствия'
    },
    {
      text: 'Преглед на възложените домашни работи'
    },
    {
      text: 'Печат на ученическа книжка и лични картони 3-48 и 3-51'
    },
  ]
}

export const protocolsModule = {
  iconComponent: 'protocols-icon',
  title: 'ПРОТОКОЛИ',
  details: [
    {
      text: 'Попълване на протоколи 3-80 и 3-82 по вид изпит'
    },
    {
      text: 'Създаване на протоколи за всички ученици, които ще се явяват на изпит'
    },
    {
      text: 'Прехвърляне към модул „Електронен дневник“ от платформата АдминПлюс на създадените изпити и въведените оценки като резултат от изпита'
    },
    {
      text: 'Въвеждане на външни за институцията лица'
    },
  ]
}